import { render, staticRenderFns } from "./paxReport.vue?vue&type=template&id=35d4af8c&scoped=true&"
import script from "./paxReport.vue?vue&type=script&lang=ts&"
export * from "./paxReport.vue?vue&type=script&lang=ts&"
import style0 from "./paxReport.vue?vue&type=style&index=0&id=35d4af8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d4af8c",
  null
  
)

export default component.exports